export class AutomateIntegrationModel {
  public id?: number;
  public accountId?: number;
  public isEnabled?: boolean;
  public companySite?: string;
  public clientId?: string;
  public clientName?: string;
  public username?: any;
  public password?: any;

  constructor(obj: any = {} as AutomateIntegrationModel) {
    this.id = obj.id;
    this.accountId = obj.accountId;
    this.isEnabled = obj.isEnabled;
    this.companySite = obj.companySite;
    this.clientId = obj.clientId;
    this.clientName = obj.clientName;
    this.username = obj.username;
    this.password = obj.password;
  }
}